var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"bb2221f0b59b0d2a9fa62f006d76e6b2ee0c9285"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["widget@swipelux-mh"]={id:"bb2221f0b59b0d2a9fa62f006d76e6b2ee0c9285"};
      